import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'eventq-alarm-indicator',
  templateUrl: './alarm-indicator.html',
  styleUrl: './alarm-indicator.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventqAlarmIndicator {
  /**
   * When true, shows the Figma viewed hollow circle.
   * When false (default), shows the unviewed red disc.
   */
  readonly viewed = input(false);
}
